import { RowCrudStatus } from "../../common/types";
import { PaymentReceiptUse } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { signedEditionDisplayId } from "../../signedEdition/store/SignedEditionCommonStore";

export type PaymentReceiptUseValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  detail: string;
  usedAt: Date | null;
  __signedEdition: string;
  showSignedEdition: { displayId: string; id: string } | null;
};

export type PaymentReceiptUseErrorsType = {
  detail?: { message: string; fieldLabel: string };
  usedAt?: { message: string; fieldLabel: string };
  signedEdition?: { message: string; fieldLabel: string };
};

export function PaymentReceiptUseValuesInit(): PaymentReceiptUseValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    detail: "",
    usedAt: null,
    __signedEdition: "",
    showSignedEdition: null,
  };
}

export type PaymentReceiptUseType =
  | PaymentReceiptUse
  | PaymentReceiptUseValuesType;

export function paymentReceiptUseDisplayId(
  source: Partial<PaymentReceiptUse>,
  _langStore: LangStore
) {
  return source.detail ?? _langStore.emptyStringSymbol;
}

export function getPaymentReceiptUseValues(
  source: PaymentReceiptUseType,
  _langStore: LangStore,
  _duplicated: boolean = false
): PaymentReceiptUseValuesType {
  const entityValues = PaymentReceiptUseValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : paymentReceiptUseDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.detail = source.detail;
  entityValues.usedAt = new Date(source.usedAt);
  entityValues.showSignedEdition =
    "signedEdition" in source && source.signedEdition
      ? {
          id: source.signedEdition.id,
          displayId: signedEditionDisplayId(source.signedEdition, _langStore),
        }
      : "showSignedEdition" in source && source.showSignedEdition
      ? {
          id: source.showSignedEdition.id,
          displayId: source.showSignedEdition.displayId,
        }
      : null;
  entityValues.__signedEdition =
    entityValues.showSignedEdition?.displayId || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
